// HM-335 cluster 16: TipologieSection - tabella 3 tipologie con
// dropdown listino assegnato. PATCH /room-types/:id pricingRuleId.

import { toast } from '@hotel-manager/ui/components';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { listPricingRules, listRoomTypesFull, updateRoomType } from '../../../api/pricing.js';

export function TipologieSection() {
  const queryClient = useQueryClient();
  const typesQuery = useQuery({ queryKey: ['room-types'], queryFn: listRoomTypesFull });
  const rulesQuery = useQuery({ queryKey: ['pricing-rules'], queryFn: listPricingRules });

  const updateMutation = useMutation({
    mutationFn: ({ id, pricingRuleId }: { id: string; pricingRuleId: string | null }) =>
      updateRoomType(id, { pricingRuleId }),
    onSuccess: () => {
      toast.success('Tipologia aggiornata');
      queryClient.invalidateQueries({ queryKey: ['room-types'] });
    },
    onError: () => toast.error('Errore aggiornamento'),
  });

  if (typesQuery.isLoading || rulesQuery.isLoading) {
    return <p className="text-text-secondary">Caricamento…</p>;
  }

  const types = (typesQuery.data?.roomTypes ?? []).filter((t) => t.active);
  const rules = rulesQuery.data?.pricingRules ?? [];

  return (
    <div
      className="bg-bg-card border border-border-base rounded-xl overflow-hidden"
      data-testid="tipologie-section"
    >
      <table className="w-full text-sm">
        <thead className="bg-bg-base text-text-secondary text-xs uppercase tracking-wide">
          <tr>
            <th className="text-left px-4 py-3 font-semibold">Codice</th>
            <th className="text-left px-4 py-3 font-semibold">Etichetta</th>
            <th className="text-left px-4 py-3 font-semibold">Listino</th>
          </tr>
        </thead>
        <tbody>
          {types.map((t) => (
            <tr
              key={t.id}
              className="border-t border-border-base"
              data-testid={`tipologia-${t.code}`}
            >
              <td className="px-4 py-3 font-mono font-semibold">{t.code}</td>
              <td className="px-4 py-3 text-text-primary">{t.label}</td>
              <td className="px-4 py-3">
                <select
                  className="border border-border-input rounded-md px-2.5 py-1.5 text-sm bg-bg-card outline-none focus:border-accent-primary min-w-[200px]"
                  value={t.pricingRuleId ?? ''}
                  onChange={(e) =>
                    updateMutation.mutate({
                      id: t.id,
                      pricingRuleId: e.target.value || null,
                    })
                  }
                  data-testid={`pricing-select-${t.code}`}
                >
                  <option value="">— Nessuno —</option>
                  {rules.map((r) => (
                    <option key={r.id} value={r.id}>
                      {r.name}
                    </option>
                  ))}
                </select>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
